import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  Goals = 'Goals',
}

export const queryKeys = {
  goals: (clientId: number) => [QueryFeature.CharitableGivingWorkflow, QueryKey.Goals, clientId],
};
